/*
 * @Description: 账户管理模块
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import style from './index.module.scss';
import { Tab } from '@alifd/next';
import MarketSend from './components/Market';
import OrderCareSend from './components/OrderCare';
import TestSend from './components/TestSms';
import utils from '@/common/utils';
import { event, store } from '@ice/stark-data';

const TabItem = Tab.Item;

/** 账户管理模块 */
const Consumption = (): JSX.Element => {
  const [currentTabKey, setCurrentTabKey] = useState('market');// 当前tab
  const tabsList = { market: '营销短信', care: '关怀短信', test: '测试短信' };// tabs字典


  useEffect(() => {
    init();
  }, [currentTabKey]);

  /** 初始化函数 */
  const init = (): void => {
    // 从父组件中获取已保存的currentTabKey，如果该可以为本页面tabs的key,则直接赋值，否则使用原有默认值
    const setPageTabKey = store.get('currentTab');
    utils.setBreadcrumb({
      name: '账户管理', // 一级页面名称
      url: '/web/orderSelection', // 一级页面url
      children: {
        name: '短信消耗记录', // 一级页面名称
        url: '/web/sms/consumption', // 一级页面url
      },
    });
  };

  return (
    <>
      <div className="setTabsStyle">

        {/* 页面tabs shape="wrapped" */}
        <Tab
          animation
          navClassName={style.tabsStyle}
          onChange={(tabkey) => setCurrentTabKey(tabkey)}
          activeKey={currentTabKey}
          className="tabStyle_hjy"
        >
          {Object.keys(tabsList).map((key) => {
            return (<TabItem title={tabsList[key]} key={key} />);
          })}
        </Tab>

        <div className={style.mainBox}>

          {currentTabKey === 'market' && (<div attr-intro="营销短信"><MarketSend /></div>)}

          {currentTabKey === 'care' && (<div attr-intro="关怀短信"><OrderCareSend /></div>)}

          {currentTabKey === 'test' && (<div attr-intro="测试短信"><TestSend /></div>)}

        </div>

      </div>

    </>

  );
};
export default Consumption;
